import {
  FAIconName,
  FireflyKebabMenu,
  FireflyKebabMenuItem,
} from '@equip.health/ui';

type Props = {
  goalTitle: string;
  onAddInterventionClick?: () => void;
  onEditClick: () => void;
  onRemoveClick: () => void;
};

export const CarePlanGoalEditMenu = ({
  goalTitle,
  onAddInterventionClick,
  onEditClick,
  onRemoveClick,
}: Props) => {
  const menuOptions: FireflyKebabMenuItem[] = [
    ...(onAddInterventionClick
      ? [
          {
            label: 'Add intervention',
            leftIcon: FAIconName.plusRegular,
            onClick: onAddInterventionClick,
          },
        ]
      : []),
    {
      label: 'Edit goal',
      leftIcon: FAIconName.penRegular,
      onClick: onEditClick,
    },
    {
      label: 'Remove goal',
      leftIcon: FAIconName.trashRegular,
      leftIconColor: 'critical.base',
      onClick: onRemoveClick,
    },
  ];

  return (
    <FireflyKebabMenu
      aria-label={`Options menu for ${goalTitle}`}
      options={menuOptions}
    />
  );
};
